import { USER } from '../constants/keyStorage'
import { NETWORK_ERROR } from '../constants/errors'
import { isObject } from 'lodash'
import qs from 'qs'

/**
 * Chuyển đổi response request về dạng JSON
 * @param {object} response một response request
 *
 * @return {object}         Một Object JSON của response
 */
function parseJSON(response) {
  if (response.status === 204 || response.status === 205) return null
  return response.json()
}

/**
 * Kiểm tra trạng thái của response và chỉ chấp nhận status trong khoảng từ 200 -> 299.
 * @param {object} response Một response của request
 * @return {object}         Response nếu status ok, ngược lại là error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  }
  if (NETWORK_ERROR[response.status]) {
    throw new Error(NETWORK_ERROR[response.status])
  }
  return response.json().then(e => {
    // const error = new Error(e.message.message || 'Lỗi không xác định')
    // throw error
    throw e
  })
}

/**
 * Hàm khởi tạo một fetch request
 * @param {string} url      Url của endpoint
 * @param {object} options  Option của fetch request
 * @param {object} config   Config sử dụng authen và baseURL hay không
 *
 * @return {object}         Object promise của fetch request
 */
export default function request(
  url,
  options,
  config = { isAuthentication: true, withBaseUrl: true }
) {
  const { isAuthentication = true, withBaseUrl = true } = config
  const commonHeader = {
    'Content-Type': 'application/json'
  }
  if (isAuthentication) {
    const userStorage = JSON.parse(localStorage.getItem(USER)) || {}
    commonHeader['Authorization'] = userStorage.accessToken
  }
  const { headers, ...rest } = options
  const newOption = {
    ...{ headers: { ...commonHeader, ...headers } },
    ...rest
  }
  Object.keys(newOption.headers).forEach((key)=>{
    if (newOption.headers[key]===undefined) {
      delete newOption.headers[key]
    }
  })
  const newUrl = withBaseUrl
    ? `${window.configSystem.BASE_URL}:${window.configSystem.PORT}${url}`
    : url
  return fetch(newUrl, newOption)
    .then(checkStatus)
    .then(parseJSON)
    .catch(error => {
      throw error
    })
}

export const requestList = (entry, pageSize, page, sorted, filtered) => {
  const sort = {}
  if (sorted && sorted.length > 0) {
    sort[sorted[0].id] = sorted[0].desc ? -1 : 1
  }
  const filter = {}
  for (let index = 0; index < filtered.length; index++) {
    const { id, value } = filtered[index]
    let valueSended = value
    if (isObject(value) && value.value && value['$valueTmp']) {
      valueSended = value.value
    }
    if (valueSended) filter[id] = valueSended
  }
  const tmp = qs.stringify({
    ...filter,
    $sort: sort,
    $skip: page * pageSize,
    $limit: pageSize
  })
  return request(`${entry}?${tmp}`, { method: 'GET' })
}
